import React from 'react';
import { AlertCircle } from 'lucide-react';

const DeleteProductModal = ({
    show,
    onClose,
    productToDelete,
    setProductToDelete,
    onConfirm
}) => {
    if (!show || !productToDelete) return null;

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50">
            <div className="bg-gray-900 rounded-xl border border-gray-800 w-full max-w-md">
                <div className="p-6 border-b border-gray-800">
                    <div className="flex items-center gap-3 mb-2">
                        <div className="w-12 h-12 bg-red-500/20 rounded-full flex items-center justify-center">
                            <AlertCircle className="w-6 h-6 text-red-400" />
                        </div>
                        <h2 className="text-xl font-bold">Delete Product</h2>
                    </div>
                    <p className="text-gray-400 mt-4">
                        Are you sure you want to delete <span className="text-white font-semibold">"{productToDelete.name}"</span>? This action cannot be undone.
                    </p>
                </div>

                <div className="p-6 flex justify-end gap-3">
                    <button
                        onClick={() => {
                            onClose();
                            setProductToDelete(null);
                        }}
                        className="px-6 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors font-medium"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium"
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteProductModal;
